import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { HOME, INICIO } from 'src/app/routes.constants';

@Component({
  selector: 'app-puerta-entrada',
  standalone: false,
  templateUrl: './puerta-entrada.component.html',
  styleUrl: './puerta-entrada.component.scss'
})
export class PuertaEntradaComponent {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  // conInquilino() {
  //   const codasesor = this.route.snapshot.queryParamMap.get('codasesor') || '';
  //   if (codasesor === '') {

  //     this.router.navigate([HOME]);
  //   } else {

  //     this.router.navigate([HOME, { codasesor }]);
  //   }

  //   const utmValidador = this.route.snapshot.queryParamMap.get('utm_campaign') || '';
  //   if (utmValidador !== '') {

  //     const utm_campaign = this.route.snapshot.queryParamMap.get('utm_campaign') || '';
  //     const utm_content = this.route.snapshot.queryParamMap.get('utm_content') || '';
  //     const utm_medium = this.route.snapshot.queryParamMap.get('utm_medium') || '';
  //     const utm_source = this.route.snapshot.queryParamMap.get('utm_source') || '';

  //     this.router.navigate([HOME, { utm_campaign, utm_content, utm_medium, utm_source }]);
  //   }
  // }

  conInquilino() {
    const codasesor = this.route.snapshot.queryParamMap.get('codasesor') || '';
    if (codasesor === '') {

      this.router.navigate(['/seguros/hogar/arriendo/cotizadores/cotizadoresder']);
    } else {
      codasesor

      //this.router.navigate([HOME, { codasesor }]);
      this.router.navigate(['/seguros/hogar/arriendo/cotizadores/cotizadoresder'], { queryParams: { codasesor } });
    }

    const utmValidador = this.route.snapshot.queryParamMap.get('utm_campaign') || '';
    if (utmValidador !== '') {

      const utm_campaign = this.route.snapshot.queryParamMap.get('utm_campaign') || '';
      const utm_content = this.route.snapshot.queryParamMap.get('utm_content') || '';
      const utm_medium = this.route.snapshot.queryParamMap.get('utm_medium') || '';
      const utm_source = this.route.snapshot.queryParamMap.get('utm_source') || '';

      this.router.navigate(['/seguros/s/hogar/arriendo/cotizadores/cotizadoresder'], { queryParams: { utm_campaign, utm_content, utm_medium, utm_source } });
    }
  }

  sinInquilino() {
    const codasesor = this.route.snapshot.queryParamMap.get('codasesor') || '';
    if (codasesor === '') {
      this.router.navigate([INICIO]);
    } else {
      
      this.router.navigate([INICIO, { codasesor }]);
    }

    const utmValidador = this.route.snapshot.queryParamMap.get('utm_campaign') || '';
    if (utmValidador !== '') {
      const utm_campaign = this.route.snapshot.queryParamMap.get('utm_campaign') || '';
      const utm_content = this.route.snapshot.queryParamMap.get('utm_content') || '';
      const utm_medium = this.route.snapshot.queryParamMap.get('utm_medium') || '';
      const utm_source = this.route.snapshot.queryParamMap.get('utm_source') || '';

      this.router.navigate([INICIO, { utm_campaign, utm_content, utm_medium, utm_source }]);
    }
  }
}
